import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '../../store';
import { blobRequest } from '../../store/photos/slice';
import ButtonDeletePhoto from '../ButtonDeletePhoto';
import Loading from '../Loading';
import { Container, Content, Image } from './styles'

interface Props {
    src: string;
    onOpen: () => void;
    onDelete: () => void;
}

// show photo in rooms
const PhotoThumb: React.FC<Props> = ({ src, onOpen = () => { }, onDelete = () => { } }) => {

    const blobState = useSelector((state: IApplicationState) => state.photos.blobs[src]);

    const dispatch = useDispatch();

    useEffect(() => {
        if (!blobState) {
            dispatch(blobRequest({
                link: src
            }))
        }
    }, [blobState, dispatch, src])

    return <Container >
        <ButtonDeletePhoto size={'medium'} prependIcon='trash' color='#ffffff' onClick={onDelete} />
        <Content onClick={onOpen} >
            {blobState && blobState.isLoading && <Loading />}
            {blobState && blobState.blob && <Image src={URL.createObjectURL(blobState.blob)} />}
        </Content>
    </Container>
}

export default PhotoThumb;